/* eslint-disable no-unused-expressions */
/*
 * Copyright (c) 2023 IQVIA Corp.  All Rights Reserved
 */
import { createSlice } from '@reduxjs/toolkit';
import { isJSONParsable } from 'utils/string';

const initialState = {
  config : null,
};

const initializeSlice = createSlice({
  name     : 'initialize',
  initialState,
  reducers : {
    initialize : (state, action) => {
      state.config = action.payload;
    },
  },
});

export const selectIsInitialized = () => (state) => !!state.initialize.config;
export const selectAppConfig = () => (state) => state.initialize.config;

export const { initialize } = initializeSlice.actions;

export default initializeSlice;
